import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import "./index.css";

Sentry.init({
  dsn: "https://f100a9f581b4dce8b051f5e5234078e4@o4504685121372160.ingest.sentry.io/4505914746208256",
  tracesSampleRate: 1.0,
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(<App />);
